import { Box, Chip, Stack, Typography } from '@mui/joy';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import useNow from "../../../hooks/useNow";

export const duration = (seconds) => {
    if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return 'Нет данных';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 1) return '< 1 мин';
    const days = Math.floor(minutes / 1440), hours = Math.floor(minutes % 1440 / 60);
    return [days ? `${days} д` : '', hours ? `${hours} ч` : '', `${minutes % 60} мин`].filter(Boolean).join(' ');
};

export default function ReadyMetrics({ metrics, completed = false }) {
    const now = useNow();
    if (!metrics) return null;
    const ready = metrics.ready_at ? Date.parse(metrics.ready_at) : NaN;
    const waiting = Number.isFinite(ready) ? Math.max(0, (now - ready) / 1000) : null;
    const late = metrics.ready_on_time === false;
    return <Box sx={{ mt: 1, p: 1.25, borderRadius: 'lg', border: '1px solid',
        borderColor: 'success.200', background: 'linear-gradient(135deg, var(--joy-palette-success-50), var(--joy-palette-background-surface))' }}>
        <Stack direction="row" gap={0.75} alignItems="center" flexWrap="wrap">
            <TaskAltRoundedIcon sx={{ color: 'success.500', fontSize: 18 }} />
            <Typography level="title-sm">Проверено · круг {metrics.round || 1}</Typography>
            <Chip size="sm" variant="soft" color={metrics.ready_on_time == null ? 'neutral' : late ? 'danger' : 'success'}>
                {metrics.ready_on_time == null ? 'Нет данных о сроке' : late ? `Позже срока на ${duration(metrics.late_seconds)}` : 'Готово в срок'}
            </Chip>
        </Stack>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1, mt: 1.25 }}>
            {[
                ['От создания до готовности', duration(metrics.total_seconds)],
                ['От назначения до сдачи', duration(metrics.drawing_seconds)],
                ['Последняя проверка', duration(metrics.qa_seconds)],
                [completed ? 'До выдачи' : 'Ожидает выдачи', duration(completed ? metrics.waiting_seconds : waiting)],
            ].map(([label, value]) => <Box key={label}>
                <Typography level="body-xs" sx={{ color: 'text.tertiary' }}>{label}</Typography>
                <Typography level="body-sm" sx={{ fontWeight: 700 }}>{value}</Typography>
            </Box>)}
        </Box>
        <Typography level="body-xs" sx={{ mt: 1, color: 'text.secondary' }}>
            {metrics.drawing_on_time == null ? 'Срок сдачи чертежа: нет данных.' : metrics.drawing_on_time ? 'Чертёж сдан в срок.' : 'Чертёж сдан позже дедлайна.'}
            {' '}{completed ? 'Результат выдан.' : 'Следующий шаг — выдать результат.'}
        </Typography>
    </Box>;
}